export default "__VITE_ASSET__CBd0ishJ__"